import { gql, useApolloClient, useMutation, } from '@apollo/client';
import { SIGNATORY_FIELDS } from 'common-app/api/fragments/bailleurs-participant';
export const SIGNATORY_WRITE = gql `
    ${SIGNATORY_FIELDS}
    mutation writeSignatory($dossierId: Long, $participants: [SignatoryFormDtoInput]!) {
      write_signatory(dossierId: $dossierId, participants: $participants) {
        ...SignatoryFields
      }
    }
  `;
export const useSignatoryWriteMutation = (options) => useMutation(SIGNATORY_WRITE, options);
export const useSignatoryWriteMutationPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.mutate(Object.assign(Object.assign({}, options), { mutation: SIGNATORY_WRITE, variables }));
};
